import { AggParam } from '../../../@core/interfaces/elastic-query.interface';
import { SearchOptions } from '../../../@core/interfaces';
import {
  BarGraphOptions, PieChartOptions, OntologyDropdownOptionsList, SelectedDropDownOptions,
} from '../../../@core/interfaces';
import { colorCode } from './plotlycolor.constants';
import { FilteredDataInterface, BuyDatasetPayload, CurationFilter } from '../@core/interfaces';
import { DropDownInterface } from 'polly-commons';
import { FilterSchemaType } from '../../../@core/interfaces/dataset-filters.interface';
import { DrawerOption } from 'polly-qubit';
export const atlasApiEndpoint: { [key: string]: string } = {
  GET_OMIXATLASES: 'v1/omixatlases',
  GET_AUDIT_SOURCE_ATLAS: 'data-audit/stats',
  QUERY_BASE: 'v1/omixatlases/queries'
};

export const geneBasedAtlasList: string[] = ['gnomad', 'ukbiobank'];

export const drugBasedAtlasList: string[] = ['cell_viability_assay', 'tyra_cell_viability_assay'];

export const singleCellsAtlasList: string[] = [
  'Single Cell RNA-Seq (Polly processed)',
  'Single cell',
  'Single Cell RNA-Seq (Raw)',
  'Single Cell RNA - Seq(Custom Processing)',
];

export const clinicalDataAtlasList: string[] = ['c_oa', 'clinical_oa_2', 'z_therapeutics'];

export const maxDescriptionLength: number = 300;

export const textEllipsisLength: number = 20;

export const operatorSuggestionForSearchDatasets: string[] = ['& AND', '| OR', '~ NOT', '() GROUP', '" " EXACT'];

export const searchOptions: SearchOptions[] = [
  { name: 'Dataset ID', value: 'dataset_id', placeholder: 'Search for datasets by their ID' },
  { name: 'Description', value: 'description', placeholder: 'Search for datasets by description' },
];

export const EXPLORER_SORT_OPTIONS: DrawerOption[] = [
  { title: 'Dataset ID', value: 'dataset_id' },
  { title: 'Number of Samples', value: 'total_num_samples' },
  { title: 'Recent Datasets', value: 'timestamp_' },
];
export const GDX_SORT_OPTIONS: DrawerOption[] = [
  { title: 'Recent Comparisons', value: 'timestamp_.keyword' },
  { title: 'Log 2 Fold', value: 'log2_fold_change' },
  { title: 'P Val', value: 'p_value' },
  { title: 'Adj P Val', value: 'padj' },
];
export const curationFilterOptions: CurationFilter[] = [
  { value: 'true', label: 'Tier 1' },
  { value: 'false', label: 'Tier 2' },
];

export const curationOptions: string[] = [
  'Genotype',
  'Strain',
  'Gene',
  'Protein',
  'Age',
  'Sex',
  'Weight',
  'Organ',
  'scRNAseq cell type annotation'
];

export const filteredValues: FilteredDataInterface = {
  searchedValue: '',
  searchOption: searchOptions[0],
  filterStatus: {},
  rangeFilter: {},
  gdxSearchData:{},
  sortParams: { sortField: 'dataset_id', sortType: 'asc', type: 'text', sortLabel: 'Dataset ID' },
  isTableViewActive: false,
};

export const binnedBarGraphData: BarGraphOptions[] = [
  {
    x: ['Group A', 'Group B', 'Group C'], // a const variable, same for all in ts file.
    y: [5, 10, 5],
    name: 'name A',
    type: 'bar',
    width: 0.2,
    text: [],
    marker: {
      color: '#4065C5',
    },
  },
];
export const barMetatadaGraphData: BarGraphOptions[] = [
  {
    x: [],
    y: [],
    name: '',
    type: 'bar',
    width: 0.4,
    marker: {
      color: [],
    },
    text: [],
  },
];
export const pieMetadataChartData: PieChartOptions[] = [
  {
    values: [],
    labels: [],
    text: [],
    hoverinfo: 'text+percent',
    insidetextorientation: 'horizontal',
    marker: {
      colors: colorCode,
      line: { color: '#ffffff', width: 1 },
    },
    type: 'pie',
    outsidetextfont: { color: 'transparent', size: 1 },
    insidetextfont: { color: '#ffffff' },
  },
];

export const repositoryDetailPayload: object = {
  size: 0,
  aggs: {
    curated_drug: {
      cardinality: {
        field: 'curated_drug.keyword',
        precision_threshold: 40000,
      },
    },
    curated_cell_line: {
      cardinality: {
        field: 'curated_cell_line.keyword',
        precision_threshold: 40000,
      },
    },
    curated_data_type: {
      cardinality: {
        field: 'curated_data_type.keyword',
        precision_threshold: 40000,
      },
    },
    curated_disease: {
      cardinality: {
        field: 'curated_disease.keyword',
        precision_threshold: 40000,
      },
    },
    curated_organism: {
      cardinality: {
        field: 'curated_organism.keyword',
        precision_threshold: 40000,
      },
    },
    curated_tissue: {
      cardinality: {
        field: 'curated_tissue.keyword',
        precision_threshold: 40000,
      },
    },
    gene_knockout: {
      cardinality: {
        field: 'gene_knockout.keyword',
        precision_threshold: 40000,
      },
    },
    curated_cell_type: {
      cardinality: {
        field: 'curated_cell_type.keyword',
        precision_threshold: 40000,
      },
    },
    gender: {
      cardinality: {
        field: 'gender.keyword',
        precision_threshold: 40000,
      },
    },
    clinical_center: {
      cardinality: {
        field: 'clinical_center.keyword',
        precision_threshold: 40000,
      },
    },
    ia_case_id: {
      cardinality: {
        field: 'ia_case_id.keyword',
        precision_threshold: 40000,
      },
    },
    t1d_case_id: {
      cardinality: {
        field: 't1d_case_id.keyword',
        precision_threshold: 40000,
      },
    },
  },
};

export const filterFieldsDrug: AggParam = {
  cell_line: { size: 1500, excludeFields: ['none'] },
  compound: { size: 1500, excludeFields: ['none'] },
  experiment: { size: 1500, excludeFields: ['none'] },
  assay_type: { size: 1500, excludeFields: ['none'] },
};

export const filterDisplayMappingDrugs: { [key: string]: string } = {
  cell_line: 'Cell Line',
  compound: 'Compound',
  experiment: 'Experiment',
  assay_type: 'Assay Type',
};

export const buyDataPayload: BuyDatasetPayload = {
  data: {
    type: 'ingestion-transaction',
    attributes: {
      datasets: [],
      source_repo_id: '',
      destination_repo_id: '',
      flags: {
        file_metadata: 'true',
        col_metadata: 'true',
        data_required: 'true'
      },
      priority: 'high'
    }
  }
};

export const selectedOntologyOptions: SelectedDropDownOptions = {
  curated_cell_line: { name: 'Cell Lines', value: 'curated_cell_line' },
  curated_drug: { name: 'Drugs', value: 'curated_drug' },
  curated_cell_type: { name: 'Cell Type', value: 'curated_cell_type' },
};
export const ontologyDropdownOptions: OntologyDropdownOptionsList = {
  curated_drug: [
    { name: 'Drugs', value: 'curated_drug' },
    { name: 'Gene', value: 'curated_gene' }],
  curated_cell_line: [
    { name: 'Cell Lines', value: 'curated_cell_line' },
    { name: 'Diseases', value: 'curated_disease' },
    { name: 'Tissues', value: 'curated_tissue' }],
    curated_cell_type: [
    { name: 'Cell Type', value: 'curated_cell_type' },
    { name: 'Tissues', value : 'curated_tissue'}
  ]
  };
export const dropDownOntologiesList = ['curated_cell_line', 'curated_drug', 'curated_cell_type'];

export const DATASET_PAGE_SIZE: number = 25;

export const DEFAULT_LOG4C = 1.5;

export const DEFAULT_PVAL = 0.05;

export const DEFAULT_ADJ_PVAL = 0.05;

export const GDX_SEARCH_TYPES: DropDownInterface[] = [
  {
    label: 'Genes',
    value: 'searchByGene',
  },
  {
    label: 'Keywords',
    value: 'searchByKeyword',
  }
];

export const AxisOptions = [
  {name: 'PC 1', value: 'pc1'},
  {name: 'PC 2', value: 'pc2'},
  {name: 'PC 3', value: 'pc3'},
  {name: 'PC 4', value: 'pc4'},
  {name: 'PC 5', value: 'pc5'},
  {name: 'PC 6', value: 'pc6'},
  {name: 'PC 7', value: 'pc7'},
  {name: 'PC 8', value: 'pc8'},
  {name: 'PC 9', value: 'pc9'},
  {name: 'PC 10', value: 'pc10'},
]

export const INITIAL_FILTER_SCHEMA_TYPE: FilterSchemaType = {
  displayNames: {},
  filterSchema: {},
  ontologyFilterSchema: {},
  additionalData: {}
}

export enum AtlasCategory {
  PUBLIC = 'public',
  PRIVATE = 'private',
  USER = 'diy_poa'
};

export const COMPARISON_TYPE_FILTER_SELECTOR: string = 'gdx__comparison_type'; // added this key as class selector for filter section of comparison type
export const EXPERIMENTAL_FACTOR_FILTER: string = 'experimental_factors';
export const extraPCARowIds: string[] = ['proportion_of_variance', 'standard_deviation', 'cumulative_proportion'];

export const HEATMAP_INFO_TEXT = 'Plot shows z-normalised values of DESeq2 normalised expression counts.';
export const VOLCANO_INFO_TEXT = 'Differential expression are calculated using DESeq2.';
export const PATHWAY_INFO_TEXT = 'Differentially expressed genes used in GSEA was selected with LogFC cutoff 1.5 and adj.p-val cutoff 0.05.';
export const VOLCANO_ERROR_TEXT = 'Update the threshold for LogFC and adj. p-value to see top differentially expressing genes';
export const PATHWAY_ERROR_TEXT = 'None of the genes are differentially expressed.';
export const HEATMAP_ERROR_TEXT = 'Go to gene expression table and update the threshold';

export const MSIGDBB_BASE_URL: string = 'https://www.gsea-msigdb.org/gsea/msigdb/cards/';
